import { jsx as n, Fragment as f } from "react/jsx-runtime";
import * as o from "react";
import { m as j } from "../node_modules/streamdown/dist/chunk-RLXIAIE6.js";
import { Renderer as U } from "../node_modules/@openuidev/react-lang/dist/Renderer.js";
import "../node_modules/@openuidev/react-lang/dist/parser/types.js";
import "../node_modules/@openuidev/react-lang/dist/context.js";
import "../node_modules/@openuidev/react-lang/dist/hooks/useFormValidation.js";
import { useCopilotInstruction as Y } from "./global-state.js";
const h = o.createContext(null), C = o.createContext(null), v = o.createContext(!1);
function _({
  children: t,
  markdown: r,
  library: e,
  libraryPromptOptions: a,
  approval: l
}) {
  const m = o.useMemo(() => {
    const i = {}, { code: k = D, pre: P = B, ...M } = r ?? {};
    Object.assign(i, M);
    const I = P, W = k;
    return i.pre = function({ children: s, ...c }) {
      if (e != null) {
        const u = s?.props?.className ?? "";
        if (u === "language-openui")
          return /* @__PURE__ */ n(f, { children: s });
        const p = s?.props?.children;
        if (!u && typeof p == "string" && p.trimStart().startsWith(`openui
`))
          return /* @__PURE__ */ n(f, { children: s });
      }
      return /* @__PURE__ */ n(I, { ...c, children: s });
    }, i.code = function({ className: c, children: u, ...p }) {
      if (c === "language-openui" && e != null)
        return /* @__PURE__ */ n(g, { response: u, library: e });
      if (e != null && typeof u == "string" && !c) {
        const d = u.trimStart();
        if (d.startsWith(`openui
`) || d.startsWith(`openui\r
`)) {
          const S = d.replace(/^openui\r?\n/, "");
          return /* @__PURE__ */ n(g, { response: S, library: e });
        }
      }
      return /* @__PURE__ */ n(W, { ...p, className: c, children: u });
    }, i;
  }, [r, e]), x = o.useMemo(() => {
    const i = e != null ? e.prompt({
      ...a,
      preamble: "When rendering UI, emit an `openui` code fence. Inside the fence, write valid openui-lang. Everything outside the fence is regular markdown."
    }) : null;
    return [
      "## Content Guidelines",
      "",
      "1. You have access to github flavored markdown. Lean on it to make your responses more readable and engaging.",
      ...i != null ? [
        "2. You can also render rich UI components inline using an `openui` code fence. When you do, the fence content must be valid openui-lang — all syntax rules, component signatures, and streaming guidelines below apply to what goes inside the fence. Your prose outside the fence should remain standard markdown.",
        "",
        i
      ] : []
    ].join(`
`);
  }, [e, a]);
  Y({ instruction: x });
  const w = o.useMemo(() => ({ components: m }), [m]);
  return /* @__PURE__ */ n(h.Provider, { value: w, children: /* @__PURE__ */ n(C.Provider, { value: l ?? null, children: t }) });
}
function g({ response: t, library: r }) {
  const e = o.useContext(v);
  return t == null || t.trim() === "" ? null : /* @__PURE__ */ n(U, { response: t.trim(), library: r, isStreaming: e });
}
function q() {
  return o.useContext(C);
}
function z({
  children: t,
  isAnimating: r = !1,
  animated: e,
  rehypePlugins: a
}) {
  const l = o.useContext(h);
  if (l == null)
    throw new Error("Markdown must be used within CopilotProvider");
  return /* @__PURE__ */ n(v.Provider, { value: r ?? !1, children: /* @__PURE__ */ n(
    j,
    {
      components: l.components,
      animated: e,
      isAnimating: r,
      rehypePlugins: a,
      children: t
    }
  ) });
}
function B(t) {
  return /* @__PURE__ */ n("pre", { ...t });
}
function D(t) {
  return /* @__PURE__ */ n("code", { ...t });
}
export {
  _ as CopilotProvider,
  z as Markdown,
  q as useCopilotApproval
};
